import React from 'react';
import { Typography } from '@wds/typography';
import packageDefs from '../Summary/packageDefs';

import { PackagePriceProps } from '~pricing/lib/summaryPackages';

export default function PackagePrice({ packageName, formattedPrice }: PackagePriceProps): React.ReactElement {
  return (
    <Typography component="h3" variant="cardTitle" data-testid="PackagePrice__Value" align="center">
      {formattedPrice}
      <Typography component="span" variant="pageTitle" data-testid="PackagePrice__Unit">
        {packageDefs[packageName]?.priceUnit}
      </Typography>
    </Typography>
  );
}
